// Group / categorization helpers shared by the overview (ProjectView) and the
// group detail page (GroupDetail).
//
// Background: groups (门店管理 / 网站 / 产品 …) were introduced in migration 0007.
// Tasks created before that — or created later without picking a 分类 in the
// new-task modal — carry a legacy free-text `category` (e.g. the old default
// "门店运营") and a NULL `groupId`. The 待办总览 cards are driven purely by
// `groupId`, so those tasks were invisible there (they only showed on the board
// with their stale category tag). These helpers surface every such task under a
// synthetic "未分类" bucket so nothing silently disappears.

import type { Task, Group } from './api.ts';

// Synthetic group id for the catch-all "未分类" card + its detail page.
export const UNGROUPED_ID = '__ungrouped__';

// The set of real group ids that currently exist. A task whose groupId is null
// OR points at a group that no longer exists counts as ungrouped.
export function knownGroupIdSet(groups: Group[]): Set<string> {
  return new Set((groups || []).map(g => g.id));
}

export function isUngrouped(task: Task, known: Set<string>): boolean {
  return !task.groupId || !known.has(task.groupId);
}

// All tasks (main + subtasks) with no valid group — the catch-all bucket.
export function ungroupedTasks(tasks: Task[], groups: Group[]): Task[] {
  const known = knownGroupIdSet(groups);
  return (tasks || []).filter(t => isUngrouped(t, known));
}

// The synthetic Group object the detail page renders for the catch-all.
export const UNGROUPED_GROUP: Group = {
  id: UNGROUPED_ID,
  name: '未分类',
  parentId: null,
  displayOrder: 9999,        // always last
  description: '没有归入任何分类的待办（多为旧待办或新建时未选分类）',
  icon: '📥',
  archived: 0,
};
